// This function allow to reference all chunks
__webpack_require__.hu = (chunkId) => {
	// return url for filenames based on template
	return "hot/" + "app" + "-hot-update.js";
};